module.exports = __webpack_public_path__ + "static/media/candle-holder.a15df9de.svg";